import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FetchData } from 'app/shared/generalMethods';
import * as moment from 'moment';
import { AdminProgramService } from 'app/services/admin-program.service';

@Component({
  selector: 'app-program-detail',
  templateUrl: './program-detail.component.html',
  styleUrls: ['./program-detail.component.scss']
})
export class ProgramDetailComponent implements OnInit {
  programId: string | null = null;
  programDetails: any = null;
  classSchedules: any[] = [];
  editingRow: { index: number, data: any, originalData: any } | null = null;
  adminId: string = '';
  isAdmin: boolean = false;
  permissions: any = {
    programs: {
      view: false,
      create: false,
      edit: false
    }
  };
  displayedColumns: string[] = ['name', 'spaces', 'fee', 'date', 'day', 'startTime', 'endTime'];

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private _fetchData: FetchData,
    private adminProgramService: AdminProgramService,
  ) {}

  ngOnInit(): void {
    const { countAdmin, countStaff, lstStaffData } = this._fetchData.data;
    this.programId = this._route.snapshot.paramMap.get('programId');

    if (countAdmin === 1) {
      this.isAdmin = true;
      this.permissions.programs = { view: true, create: true, edit: true };
    }

    if (countAdmin === 0 && countStaff === 1 && lstStaffData && lstStaffData.length > 0) {
      this.parseStaffPermissions(lstStaffData[0].Permission_Sets__c);
    }

    // Add actions column if user has edit permission
    if (this.canEdit()) {
      this.displayedColumns.push('actions');
    }

    this.getProgramDetails();
    this.getClassSchedules();
  }

  private parseStaffPermissions(permissionSets: string): void {
    if (!permissionSets) return;

    try {
      const decodedPermissions = permissionSets.replace(/&quot;/g, '"');
      const permissions = JSON.parse(decodedPermissions);
      
      if (permissions.programs) {
        this.permissions.programs = {
          view: permissions.programs.view || false,
          create: permissions.programs.create || false,
          edit: permissions.programs.edit || false
        };
      }
    } catch (error) {
      console.error('Error parsing permissions:', error);
    }
  }

  canEdit(): boolean {
    return this.isAdmin || this.permissions.programs.edit;
  }
   getAdminId(): string {
  // Ensure programDetails is loaded and contains the field
  if (this.programDetails && this.programDetails.Administrator__c) {
    return this.programDetails.Administrator__c;
  }
   }

  getProgramDetails(): void {
    const programList = this._fetchData.data?.lstPrograms;

    if (this.programId && programList && Array.isArray(programList)) {
      this.programDetails = programList.find(
        (program: any) => program?.Id === this.programId
      );

      if (!this.programDetails) {
        this._snackBar.open('Program not found.', 'Close', {
          duration: 3000
        });
      }
    } else {
      this._snackBar.open('Program data not available.', 'Close', {
        duration: 3000
      });
    }
  }

  getClassSchedules(): void {
    const scheduleList = this._fetchData.data?.lstClassSchedules;

    if (this.programId && scheduleList && Array.isArray(scheduleList)) {
      this.classSchedules = scheduleList
        .filter((schedule: any) => schedule?.Program__c === this.programId)
        .map((schedule: any) => ({
          ...schedule,
          formattedStartTime: this.formatTime(schedule.Start_Time__c),
          formattedEndTime: this.formatTime(schedule.End_Time__c)
        }));
    } else {
      this._snackBar.open('Class schedules not available.', 'Close', {
        duration: 3000
      });
    }
  }
  startEditing(index: number, schedule: any): void {
    this.editingRow = {
      index,
      data: JSON.parse(JSON.stringify(schedule)),
      originalData: schedule
    };
  }

  cancelEditing(): void {
    this.editingRow = null;
  }

  saveChanges(): void {
    if (!this.editingRow) return;

    const { data } = this.editingRow;
    const adminId = localStorage.getItem('adminId');
    this.adminProgramService.updateClassSchedule(data, adminId).subscribe(
      (response) => {
        const results: any = this._fetchData.parseIntoJSON(response.msg);
        if (results.success) {
          this._snackBar.open('Schedule updated successfully!', 'Close', {
            duration: 3000
          });
          // Update the local data
          Object.assign(this.editingRow.originalData, data);
          this._fetchData.setLocalStorage(response.msg);
          this.editingRow = null;
        } else {
          this._snackBar.open('Error updating schedule. Please try again.', 'Close', {
            duration: 3000
          });
        }
      },
      (err) => {
        this._snackBar.open('Error updating schedule. Please try again.', 'Close', {
          duration: 3000
        });
      }
    );
  }

  formatTime(timeStr: string): string {
    if (!timeStr) {return '';}
    return moment.utc(timeStr, 'HH:mm:ss.SSSZ').format('hh:mm A');
  }
}
